/**
 * The operator note (the free-text status shown next to a profile) is capped at
 * 120 server-side: `operatornote` is a varchar(120) on both `account` and
 * `accountprofile`, and the API rejects anything longer with a 400 (AC-1549).
 *
 * We count UTF-16 code units, matching both `maxLength` and the Java-side
 * check. The column counts codepoints, so an astral character (most emoji)
 * costs two here but one there — deliberately the stricter of the two, so the
 * field can never produce a note either layer would reject.
 *
 * Applies to every write path, since they all funnel through the same service
 * validation — including the channel live-chat greeting, which is stored in
 * `operatornote` despite being presented as a greeting rather than a status.
 */
export const OPERATOR_NOTE_MAX_LENGTH = 120;

/**
 * Length at which the character counter is revealed. An always-visible counter
 * on an optional status field reads as pressure to fill it, so it only appears
 * once the remaining room is worth knowing about.
 */
export const OPERATOR_NOTE_COUNT_FROM = 100;

/**
 * `maxLength` constrains typing, not a value that arrived already too long.
 * Reachable today: before the server-side check existed, a note of ~100 emoji
 * was 100 codepoints (so it fit the column) but 200 UTF-16 units. Every submit
 * path needs this — the counter alone does not stop a save.
 */
export const operatorNoteIsOverLimit = (note?: string) =>
    (note?.length ?? 0) > OPERATOR_NOTE_MAX_LENGTH;
